// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitle_container__2Ru5a","title":"PageTitle_title__1OOw7","divider":"PageTitle_divider__2_l5M"};